/* eslint-disable @typescript-eslint/no-explicit-any */
import { resolveImageReferenceToImage } from './imageResolver';
import { type LocationMapItem } from '4-sections/FilteredListings/MapAndListing/Map/ListingMap';
import { generateDescription, type LocationCardResolverSettings, type LocationPage } from './locationCardResolver';
import { getApiHostname } from 'cms/constants';
import type { ImageProps } from '2-core-elements/Image/Image';

export type LocationPageItems = LocationPage[];

export const resolveLocationPagesToMapItems = (items: LocationPageItems, settings: LocationCardResolverSettings): LocationMapItem[] => {
    return items.map((item: any) => {
        // // the autogenerated produce | null for each item, need to remove the | null type
        const {
            url,
            title,
            physicalLocation,
            phoneNumber,
            image,
            latitude,
            longitude,
            // Countries
        } = item as NonNullable<typeof item>;
        const { emailLabel, telLabel } = settings;
        const fetchUrl = getApiHostname();
        const img = resolveImageReferenceToImage(`${fetchUrl}${image.url}`);
        const id = `${title}${latitude}`;

        const coordinates = {
            lat: Number(latitude),
            lon: Number(longitude),
        };

        const description = generateDescription({ physicalLocation, phoneNumber, emailLabel, telLabel, hasHeading: true });

        return {
            id,
            name: title as string,
            description,
            ...(img) as ImageProps,
            coordinates,
            href: url,
        };
    });
};
